<template>
	<div id="menu" class="navbar navbar-default navbar-static-top container-fluid">
		<ul class="nav nav-justified">
			<li @click="habilitarVoltar">
				<router-link to="/cadastro">
					<i v-if="telaInicial" class="bi bi-activity btn btn-success btn-sm">CADASTRAR</i>
					<i v-else class="bi bi-activity btn btn-success btn-sm" @click="acessarCadastrese">PÁGINA INICIAL</i>
				</router-link>
			</li>
			<li v-for="v in votacoes" :key="v.id" style="list-style-type:none;" @click="abrirVotacao(v.id)">
				<router-link class="opcaoVotacao" to="/votacao" style="margin:5px;">
					<i class="bi bi-activity btn btn-success btn-sm">VOTAÇÃO</i>
				</router-link>
			</li>
			<li style="list-style-type:none;margin:5px;">
				<b><a ref="listaSelecionada"></a></b>
			</li>
		</ul>
	</div>
</template>

<script>
	import $ from 'jquery';
	import Votacao from '../../models/votacao';
	import Main from '../commons/Home/index';
	import Vue from 'vue';

	export default {
		data() {
			return {
				votacoes: [],
				opcoes: [],
				idVotacao: 0,
				telaInicial: true
			};
		},

		created: async function() {
			this.votacoes = (await Votacao.listarVotacoes()).data;
		},

		methods: {
			abrirVotacao: async function(id) {
				var vue = this;
				vue.telaInicial = false;
				this.$emit('menuAcessado', this.telaInicial);
				$('.opcaoVotacao').remove();
				for (var ix = 0; ix < this.votacoes.length; ix++) {
					if (this.votacoes[ix].id === id) {
						vue.idVotacao = id;
						this.$refs.listaSelecionada.text = this.votacoes[ix].descricao + ' de ' + this.votacoes[ix].inicioJSON + ' até ' + this.votacoes[ix].fimJSON;
						var telaOpcoesVotacao = Vue.extend(Main);
						var instanciaVotacao = new telaOpcoesVotacao();
						instanciaVotacao.opcoes = (await Votacao.carregarVotacao(id)).data;
						instanciaVotacao.idVotacao = id;
						instanciaVotacao.interno = this.votacoes[ix].interno;
						instanciaVotacao.$mount('main');
					}
				}
			},

			acessarCadastrese: function() {
				//this.$emit('menuAcessado', this.telaInicial);
				this.$emit('menuAcessado', false);
				this.$router.push('/');
				window.location.reload();
			},

			habilitarVoltar: function() {
				this.telaInicial = false;
				this.$emit('menuAcessado', this.telaInicial);
			}
		}
	};
</script>

<style scoped>
	#menu {
		min-height:30px;
		margin-bottom: 0px;
		z-index:0;
		background-color: white;
	}
	li > a {
		border-bottom: solid 3px transparent;
	}
	li > a.router-link-active, .linkCadastrar {
		color: #2f6696;
		border-bottom-color: #2f6696;
	}
</style>